import axios from "../http";

class Operate {
  //客户列表
  static getCustomerList(warehouseId, billDate, currentPage) {
    const url = `/oa/api/warehouse/bill/project/list?warehouseId=${warehouseId}&billDate=${billDate}&currentPage=${currentPage}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 日报详情
  static getDailyDetails(warehouseId, billDate) {
    const url = `/oa/api/warehouse/bill/detail?warehouseId=${warehouseId}&billDate=${billDate}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 导出日报
  static getExportExcel(warehouseId, billDate) {
    const url = `/oa/api/download/warehouse/bill/day?warehouseId=${warehouseId}&billDate=${billDate}`;
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
  // 人工成本设置
  static postLaborCostSet(data) {
    const url = `/oa/api/emp/cost/update/employee/cost`;
    return axios.post(url,data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 客户单报
  static getCustomerSingleReport(projectId, date) {
    const url = `/oa/api/customer/single/report/detail?projectId=${projectId}&date=${date}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑收入金额
  static postModIncome(data) {
    const url = `/oa/api/customer/single/report/update/income`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑成本金额
  static postModCost(data) {
    const url = `/oa/api/customer/single/report/update/cost`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 历史记录
  static getHistoricalRecordsList(id, type, dataType, date) {
    const url = `/oa/api/customer/single/report/history?id=${id}&type=${type}&dataType=${dataType}&date=${date}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Operate;